/**
 * Supabase「忘记密码」邮件中的 redirect 地址，须与控制台 Authentication → URL Configuration
 * 的 Redirect URLs 完全一致（含生产、本地）。
 *
 * 可选环境变量：VITE_AUTH_PASSWORD_RESET_REDIRECT=https://你的域名/index-app.html
 *
 * 控制台应填写的 URL 清单见：supabase/README.md →「Authentication：忘记密码 / Redirect URLs」
 */
export function getPasswordResetRedirectTo(): string {
  const env = import.meta.env.VITE_AUTH_PASSWORD_RESET_REDIRECT as string | undefined;
  if (env && /^https?:\/\//i.test(env.trim())) {
    return env.trim().replace(/\/$/, '');
  }
  if (typeof window === 'undefined') return '';
  const { origin, pathname } = window.location;
  const path = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
  return `${origin}${path}` || origin;
}
